import { useCallback } from 'react';
import { useStytchUpdateMember } from '../../../services/stytch/client/member/stytch-update-member-hooks';
import { useStytchUpdateSelf } from '../../../services/stytch/client/member/stytch-update-self-hooks';
import { useStytchDeleteMfaPhoneNumber } from '../../../services/stytch/client/member/stytch-delete-mfa-hooks';
import { useStytchDeleteMfaTotp } from '../../../services/stytch/client/member/stytch-delete-mfa-hooks';
/**
 * Hook to update member
 */
export function useUpdateMember() {
    const updateMember = useStytchUpdateMember();
    return useCallback(async (data) => {
        const result = await updateMember(data);
        if (result.success) {
            return {
                success: true,
                requestId: result.requestId,
                statusCode: result.statusCode,
                memberId: result.memberId,
                member: result.member,
                organization: result.organization,
                data: result.data,
            };
        }
        else {
            return {
                success: false,
                error: result.error,
                data: result.data,
            };
        }
    }, [updateMember]);
}
/**
 * Hook to delete MFA phone number
 */
export function useDeleteMfaPhoneNumber() {
    const deleteMfaPhoneNumber = useStytchDeleteMfaPhoneNumber();
    return useCallback(async (data) => {
        const result = await deleteMfaPhoneNumber(data);
        if (result.success) {
            return {
                success: true,
                requestId: result.requestId,
                statusCode: result.statusCode,
                memberId: result.memberId,
                member: result.member,
                organization: result.organization,
                data: result.data,
            };
        }
        else {
            return {
                success: false,
                error: result.error,
                data: result.data,
            };
        }
    }, [deleteMfaPhoneNumber]);
}
/**
 * Hook to delete MFA TOTP
 */
export function useDeleteMfaTotp() {
    const deleteMfaTotp = useStytchDeleteMfaTotp();
    return useCallback(async (data) => {
        const result = await deleteMfaTotp(data);
        if (result.success) {
            return {
                success: true,
                requestId: result.requestId,
                statusCode: result.statusCode,
                memberId: result.memberId,
                member: result.member,
                organization: result.organization,
                data: result.data,
            };
        }
        else {
            return {
                success: false,
                error: result.error,
                data: result.data,
            };
        }
    }, [deleteMfaTotp]);
}
/**
 * Hook for updating the current member's own profile and MFA settings.
 *
 * Uses self.update() which:
 * - Automatically infers the organization from the session
 * - Doesn't require admin permissions for self-updates
 * - Is ideal for MFA enrollment, phone number, and preferences
 */
export function useUpdateSelf() {
    const updateSelf = useStytchUpdateSelf();
    return useCallback(async (data) => {
        const result = await updateSelf(data);
        if (result.success) {
            return {
                success: true,
                requestId: result.requestId,
                statusCode: result.statusCode,
                memberId: result.memberId,
                member: result.member,
                organization: result.organization,
            };
        }
        else {
            return {
                success: false,
                error: result.error,
            };
        }
    }, [updateSelf]);
}
